import React from 'react';
import { useParams } from 'react-router-dom';
import { createUseStyles } from 'react-jss';
import { useGetEntriesStateQuery } from '../../api/phoenix';
import GlobalEmptyState from '../../components/GlobalEmptyState/GlobalEmptyState';
import { Headline } from '../../elements';
import theme from '../../constants/Theme';
import Diary from '../../components/Diary/Diary';
import LoadingOverlay from '../../components/LoadingOverlay/LoadingOverlay';
import Widgets from '../../components/Widgets/Widgets';

export default function Detail() {
  const { id } = useParams();
  const { data: diaryEntriesState, isLoading: diaryEntriesStateLoading } = useGetEntriesStateQuery(
    { id: id || '' },
    { skip: !id }
  );

  const isLoading = diaryEntriesStateLoading;
  const classes = useStyles();

  if (isLoading) {
    return <LoadingOverlay isLoading={isLoading} />;
  }

  return !diaryEntriesState?.data.diaryEntries ? (
    <main className={classes.main}>
      <Headline>Hörtagebuch Auswertung</Headline>
      <GlobalEmptyState />
    </main>
  ) : (
    <main className={classes.main}>
      <Headline>Hörtagebuch Auswertung</Headline>
      <Widgets id={id || ''} />
      <Diary id={id || ''} />
    </main>
  );
}

const useStyles = createUseStyles({
  '@global': {
    'html, body, #root': {
      display: 'flex',
      flex: '1 1 0%',
      height: '100%',
      margin: 0,
    },
    body: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 400,
      lineHeight: '16px',
    },
  },
  '@font-face': [
    {
      fontFamily: 'FF DIN Web Pro',
      src: "url('/fonts/FFDINWebProRegular.woff2') format('woff2'), url('/fonts/FFDINWebProRegular.woff') format('woff')",
      fontWeight: 400,
      fontStyle: 'normal',
      lineHeight: 16,
    },
    {
      fontFamily: 'FF DIN Web Pro',
      src: "url('/fonts/FFDINWebProBold.woff2') format('woff2'), url('/fonts/FFDINWebProBold.woff') format('woff')",
      fontWeight: 700,
      fontStyle: 'normal',
    },
  ],
  main: {
    paddingLeft: '60px',
    paddingRight: '60px',
    paddingTop: '30px',
    paddingBottom: '30px',
    display: 'flex',
    flexDirection: 'column',
    lineHeight: '16px',
    flex: '1 1 0%',
  },
});
